import { R0Variant } from './R0Component.types';
export const isR0Variant = (variant?: R0Variant) => variant === 'R0';
